import ConsolidatedShabihSazReports from './component';

export const initialState = {};
export const component = ConsolidatedShabihSazReports;
